import * as React from "react";
import TabSet from "../../../hiberUiKit/src/molecules/TabSet/TabSet";
import Tab from "../../../hiberUiKit/src/atoms/Tab/Tab";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import TabSetContent from "../../../hiberUiKit/src/molecules/TabSet/TabSetContent";
import {Option} from "ts-option";
import Transaction from "../../../model/transaction/Transaction";
import AccountingNote from "../../../model/invoice/note/AccountingNote";
import StripePayout from "../../../model/transaction/StripePayout";
import {api} from "../../../api/api";
import AccountingNoteTab from "../common/AccountingNoteTab";
import {OnFailure, OnSuccess} from "../../../store/action/actionHelpers";
import GoCardlessPayout from "../../../model/transaction/GoCardlessPayout";

interface IProps {
	/**
	 * Transaction.
	 */
	transaction: Option<Transaction | StripePayout | GoCardlessPayout>;
	/**
	 * Note to edit.
	 */
	noteToEdit: Option<AccountingNote>
	/**
	 * On add note success callback.
	 */
	onAddNoteSuccess?: (note: AccountingNote) => void;
	/**
	 * On edit note success callback.
	 */
	onUpdateNoteSuccess?: (note: AccountingNote) => void;
}

export default class TransactionActivityTabs extends React.Component<IProps, {}> {
	render() {
		return (
			<React.Fragment>
				<TabSet>
					<Tab icon={Icon.Note} label={"Notes"} tabId={TransactionTab.Note} selectedTabId={TransactionTab.Note}/>
				</TabSet>
				<TabSetContent isWhite={true}>
					<AccountingNoteTab
						addNote={this.addNote}
						updateNote={this.updateNote}
						noteToEdit={this.props.noteToEdit}/>
				</TabSetContent>
			</React.Fragment>
		);
	}

	addNote = (noteContent: string, onSuccess: OnSuccess, onFailure: OnFailure) =>
		this.props.transaction.map(t => {
				const successCallback = (note: AccountingNote) => {
					this.props.onAddNoteSuccess(note);
					onSuccess();
				};
				api.instance.noteApi.createTransactionNote(t.id, noteContent)
					.then(successCallback)
					.catch(onFailure);
			}
		);

	updateNote = (noteId: string, noteContent: string, onSuccess: OnSuccess, onFailure: OnFailure) =>
		this.props.transaction.map(t => {
				const successCallback = (note: AccountingNote) => {
					this.props.onUpdateNoteSuccess(note);
					onSuccess();
				};
				api.instance.noteApi.updateTransactionNote(noteId, t.id, noteContent)
					.then(successCallback)
					.catch(onFailure);
			}
		);
}

export enum TransactionTab {
	Note = "note"
}
